import styled from 'styled-components'
import { media, rgba, radiuses } from 'styles'
import Icon from 'components/Icon/StyledIcon'

const iconBackground = rgba('black', 0.6)

const mainPadding = '1.5rem'

const StyledGalleryModal = styled.div`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  max-height: 100%;

  .main {
    position: relative;
    width: 100%;
    max-width: 80vw;
    margin-right: 1rem;

    .main-image {
      width: auto;
      height: auto;
      max-height: 80vh;
      max-width: 100%;
      min-width: 200px;
      min-height: 200px;
      border-radius: ${radiuses.medium};
      align-self: flex-end;
    }
  }

  .image-amount,
  .set-as-default {
    position: absolute;
    bottom: ${mainPadding};

    display: flex;
    align-items: center;

    padding: 1rem 1.5rem;
    color: white;
    background-color: ${iconBackground};
    border-radius: 0.4rem;

    i {
      margin-right: 0.5rem;
      color: white;
    }
  }
  .image-amount {
    top: ${mainPadding};
    bottom: auto;
    left: ${mainPadding};
    font-size: 1.4rem;
  }
  .set-as-default {
    left: ${mainPadding};
    font-size: 1.2rem;
    cursor: pointer;
  }

  .top-right-controls {
    position: absolute;
    top: ${mainPadding};
    right: ${mainPadding};

    display: flex;

    .item {
      padding: 0.8rem;
      border-radius: 0.5rem;
      background: ${iconBackground};
      cursor: pointer;
      z-index: 1;

      i {
        font-size: 1.8rem;
        color: white;
      }

      & ~ .item {
        margin-left: 1rem;
      }
    }
  }

  .arrows {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    display: none;

    i {
      font-size: 3.4rem;
      color: white;
    }

    ${Icon} {
      position: relative;
      cursor: pointer;

      &:first-of-type {
        left: -4rem;
      }

      &:last-of-type {
        right: -4rem;
      }
    }
  }

  .image-list {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
    align-content: flex-start;
    flex: 1;
    max-width: 20vw;
    width: 100%;
    margin: -0.8rem;
  }

  ${media.mobile`
    flex-flow: column nowrap;

    .main {
      width: auto;
      margin-right: 0;
    }

    .image-list {
      width: 100%;
      max-width: initial;
      margin-top: 1rem;
      flex-flow: row wrap;
    }

    .arrows {
      ${Icon} {
        &:first-of-type {
          left: -3rem;
        }

        &:last-of-type {
          right: -3rem;
        }
      }
    }
  `}
`

const StyledGalleryItem = styled.div`
  width: 6vw;
  min-width: 3rem;
  padding: 0.4rem;
  box-sizing: border-box;
  cursor: pointer;
  flex: 0 1 auto;

  .active-indicator {
    box-sizing: border-box;
    border-radius: ${radiuses.small};
    border: 3px solid ${p => (p.active ? p.theme.colors.highlight : 'transparent')};
  }

  .avatar-img {
    border-radius: ${radiuses.small};
  }
  ${media.mobile`
    width: 25%;
    min-width: 3rem;
    &.upload {
      order: -1;
    }
  `}
`

export default StyledGalleryModal
export { StyledGalleryItem }
